const FETCH_CUSTOMER_LINKS = 'FETCH_CUSTOMER_LINKS'
const REFRESH_CUSTOMER_LINKS = 'REFRESH_CUSTOMER_LINKS'

export {
    FETCH_CUSTOMER_LINKS,
    REFRESH_CUSTOMER_LINKS
}
